import packageJson from '../../../package.json'

/**
 * Dynamically constructs the PDF.js worker URL based on the installed pdfjs-dist version.
 * This prevents version mismatches between the main library and worker script.
 */
export const getPdfWorkerUrl = (): string => {
  const pdfjsVersion = packageJson.dependencies['pdfjs-dist']

  if (!pdfjsVersion) {
    throw new Error('pdfjs-dist version not found in package.json dependencies')
  }

  // Remove any version prefixes (^, ~) to get clean version
  const cleanVersion = pdfjsVersion.replace(/^[\^~]/, '')

  return `https://unpkg.com/pdfjs-dist@${cleanVersion}/build/pdf.worker.min.js`
}
